module.exports = __webpack_public_path__ + "media/ss_photos/ss-overview-photo-02-26955e0d.webp";